import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, interval } from 'rxjs';
import { GeoModel } from 'src/app/shared/models/geo/geo.model';
import { AuthenticationService } from '../login/authentication/authentication.service';
import { ToastService } from './toast/toast.service';
declare var geoposition: any;
declare var deviceId: any;
declare var tokenOS: any;
declare var notificationReceived: any;
declare function OpenLink(url: string): any;
@Injectable({
  providedIn: 'root'
})
export class SubProcesosService implements OnDestroy {
  url!: string;
  geoMovilOrWeb: boolean = true;
  geoSubject: BehaviorSubject<GeoModel | null> = new BehaviorSubject<GeoModel | null>(null);
  notiSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private geoIntervalSub: Subscription = Subscription.EMPTY;
  private notificationIntervalSub: Subscription = Subscription.EMPTY;

  constructor(private msg: ToastService) {
    // this.initSubGeo();
    this.initNotification();
  }

  //ANDROID ID  

  getDeviceId() {
    //deviceId = deviceId == null ? '03975e25-54be-4ca4-b52d-7ae8557bab36' : deviceId;
    return deviceId;
  }

  //GEOLOCATION

  initSubGeo() {
    this.stopSubGeo();
    this.geoIntervalSub = interval(1000).subscribe(() => {
      // this.geoSubject.next(geoposition);
      this.setGeo(geoposition);
    });
  }

  stopSubGeo() {
    this.geoIntervalSub.unsubscribe();
    this.geoIntervalSub = Subscription.EMPTY;
  }

  setGeo(geo: GeoModel | null) {
    const currentGeo = this.toGeoModel(this.geoMovilOrWeb ? geo : geoposition);
    this.geoSubject.next(currentGeo);
  }

  subGeo(): Observable<GeoModel | null> {
    return this.geoSubject.asObservable();
  }

  getGeo(): GeoModel | null {
    return this.toGeoModel(geoposition);
  }

  //Token One Signal
  getToken() {
    return tokenOS;
  }

  //notification
  initNotification() {
    this.stopNotification();
    this.notificationIntervalSub = interval(1000).subscribe(() => {
      if (!notificationReceived) {
        return;
      }

      const notificationId = this.getNotificationId(notificationReceived);
      if (notificationId && this.notiSubject.value.some(x => this.getNotificationId(x) == notificationId)) {
        return;
      }

      if (!notificationId && this.notiSubject.value.some(x => x == notificationReceived)) {
        return;
      }

      this.msg.showInfoNotification("Mensaje recibido", 7000);
      var aux = this.notiSubject.value;
      aux.push(notificationReceived);
      this.notiSubject.next(aux);
      notificationReceived = null;
    });
  }

  stopNotification() {
    this.notificationIntervalSub.unsubscribe();
    this.notificationIntervalSub = Subscription.EMPTY;
  }

  subNoti() {
    return this.notiSubject.asObservable();
  }

  deleteNoti(id_mensaje: string) {
    var index = this.notiSubject.value.findIndex(x => {
      if (typeof x === 'string') {
        return x.includes(id_mensaje);
      }

      return this.getNotificationId(x) == id_mensaje;
    });

    if (index != -1) {
      var aux = this.notiSubject.value;
      aux.splice(index, 1);
      this.notiSubject.next(aux);
    }
  }

  private getNotificationId(notification: any): string | null {
    if (!notification) {
      return null;
    }

    if (typeof notification === 'string') {
      try {
        return JSON.parse(atob(notification)).NotificationId ?? null;
      } catch (error) {
        try {
          return JSON.parse(notification).NotificationId ?? null;
        } catch {
          return null;
        }
      }
    }

    return notification.NotificationId ?? notification.id_mensaje ?? null;
  }

  abrirEnlace(url: string) {
    OpenLink(url);
  }

  private toGeoModel(geo: any): GeoModel | null {
    if (!geo) {
      return null;
    }

    if (geo instanceof GeoModel) {
      return geo;
    }

    return new GeoModel(
      geo.lat,
      geo.lng,
      geo.degrees,
      geo.velocity,
      geo.last
    );
  }

  ngOnDestroy(): void {
    this.stopSubGeo();
    this.stopNotification();
  }

}